module.exports = __webpack_public_path__ + "static/media/red-car.382b6267.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/red-car.png
// module id = 3310
// module chunks = 0